import { get } from "jquery";
import { update } from "react-spring";
//const backendDomain = "http://192.168.1.59:3001/api";
//const backendDomain = "http://192.168.1.254:3001/api";
const backendDomain = "https://qaSkillara.org/api";
const SummaryApi = {
  Images: {
    url: `${backendDomain}`,
  },
  Instructormobileverification: {
    url: `${backendDomain}/instructor_email_verification`,
    method: "post",
  },
  instructorpasswordverification:{
       url: `${backendDomain}/instructor_password_verification`,
    method: "post",
},
  InstructorOtpVerification: {
    url: `${backendDomain}/instructor_verify_otp`,
    method: "post",
  },
  createInstructor: {
    url: `${backendDomain}/instructor_create`,
    method: "post",
  },
  instructorLogin: {
    url: `${backendDomain}/instructor_login`,
    method: "post",             
  },
  instructorLoginStatus: {
    url: `${backendDomain}/instructor_login_status`,  
    method: "post",
  },
  courseByInstructorId: {
    url: `${backendDomain}/instructor_active_courses`,
    method: "post",
  },
  instructorCourseImage: {
    url: `${backendDomain}`,
  },
   getActiveInstructors: {
    url: `${backendDomain}/instructor_retrieve_all_active`,
    method: "get",
  },
  instructorcoursesByCategoryId: {
    url: `${backendDomain}/courses_retrieve_by_category_id`,
    method: "post",
  },
  instructorDetailsByInstructorId: {
    url: `${backendDomain}/instructor_full_name_by_id`,
    method: "post",
  },
  createInstructorTimeslot: {
    url: `${backendDomain}/time_slot_create`,
    method: "post",
  },
  instructorTimeslotByInstructorId: {
    url: `${backendDomain}/instructor_timeslots`,
    method: "post",
  },
updateInstructorTimeSlot:{
    url: `${backendDomain}/time_slot_update`,
    method: "post",
},
  instructorByCourseId: {
    url: `${backendDomain}/course_instructor_details`,
    method: "post",
  },
  instructorImage: {
    url: `${backendDomain}`,
  },
  instructordetailsById: {
    url: `${backendDomain}/instructor_retrieve_by_id`,
    method: "post",
  },
  coursedetailsById: {
    url: `${backendDomain}/course_retrieve_by_id`,
    method: "post",
  },
  timeslotByCourseIdAndInstructorId: {
    url: `${backendDomain}/instructor_course_timeslots`,
    method: "post",
  },
instructorfulldetails: {
    url: `${backendDomain}/instructor_by_id_full_details`,
    method: "POST",
  },
  instructortodayschedule: {
    url: `${backendDomain}/today_instructor_time_slot_retrieve_all`,
    method: "POST",
  },
InstructorDashboardCounts: {
    url: `${backendDomain}/instructor_dashboard_counts`,
    method: "POST",
  },
createInstructorCourse:{
     url: `${backendDomain}/instructor_course_create`,
    method: "POST",
},
getCourseIdByInstructorId:{
  url: `${backendDomain}/instructor_course_by_instructor`,
    method: "POST",
},

  getActiveCategories: {
    url: `${backendDomain}/category_retrieve_all_active`,
    method: "get",
  },

  coursesByCategoryId: {
    url: `${backendDomain}/courses_retrieve_by_category_id`,
    method: "post",
  },
 
  getActiveCourses: {
    url: `${backendDomain}/course_retrieve_all_active`,
    method: "get",
  },


  getActiveInstructorCourses: {
    url: `${backendDomain}/course_retrieve_all_active_instructor`,
    method: "get",
  },










  getActiveTrendyCourses: {
    url: `${backendDomain}/course_retrieve_all_trendy_active`,
    method: "get",
  },
  getActiveCarrerCourses: {
    url: `${backendDomain}/course_retrieve_all_career_active`,
    method: "get",
  },
  getTimeslotsByCourseId:{
    url: `${backendDomain}/course_time_slot_details`,
    method: "post",
  },
  // Student Starts

  studentLogin: {
    url: `${backendDomain}/student_login`,
    method: "post",
  },
  studentmobileverification: {
    url: `${backendDomain}/student_mobile_verification`,
    method: "post",
  },
  studentPasswordVerification:{
    url: `${backendDomain}/student_password_verification`,
    method: "post",
  },
  StudentOtpVerification: {
    url: `${backendDomain}/student_verify_otp`,
    method: "post",
  },
  getStudentById: {
    url: `${backendDomain}/student_retrieve_by_id`,
    method: "post",
  },

getTimeslotByStudentId:{
 url: `${backendDomain}/enrollment_retrieve_by_student`,
    method: "POST",
  },
  
  getCourseByStudentId:{
    url: `${backendDomain}/course_retrieve_by_student`,
    method: "POST",
  },
  updateStudent:{
    url: `${backendDomain}/student_update`,
    method: "POST",
  },
  // Admin starts

  AdminLogin: {
    url: `${backendDomain}/login`,
    method: "POST",
  },

  fetchstudentnames: {
    url: `${backendDomain}/student_retrieve_all`,
    method: "GET",
  },

  fetchingstudentbyid: {
    url: `${backendDomain}/student_admin_retrieve_by_id`,
    method: "POST",
  },

  studentupdate: {
    url: `${backendDomain}/student_update`,
    method: "POST",
  },

  Instructorcreate: {
    url: `${backendDomain}/instructor_admin_create`,
    method: "POST",
  },

  Instructorupdate: {
    url: `${backendDomain}/instructor_update`,
    method: "POST",
  },

  InstructorList: {
    url: `${backendDomain}/instructor_retrieve_all`,
    method: "GET",
  },

  InstructorByid: {
    url: `${backendDomain}/instructor_admin_retrieve_by_id`,
    method: "POST",
  },

  InstructorActivation: {
    url: `${backendDomain}/instructor_activate`,
    method: "POST",
  },

  instructordashboardbyid: {
    url: `${backendDomain}/instructor_by_id_full_details`,
    method: "POST",
  },

  Collegecreate: {
    url: `${backendDomain}/college_create`,
    method: "POST",
  },

  Collegeupdate: {
    url: `${backendDomain}/college_update`,
    method: "POST",
  },

  CollegeList: {
    url: `${backendDomain}/college_admin_retrieve_all`,
    method: "GET",
  },

  CollegeById: {
    url: `${backendDomain}/college_retrieve_by_id`,
    method: "POST",
  },

  fetchcollegenames: {
    url: `${backendDomain}/get_college_names`,
    method: "GET",
  },

  uploadexcel: {
    url: `${backendDomain}/upload_excel`,
    method: "POST",
  },

  CategoryList: {
    url: `${backendDomain}/category_retrieve_all`,
    method: "GET",
  },
getActiveCourseCategory: {
    url: `${backendDomain}/category_retrieve_all_active`,
    method: "get",
  },
  Categorycreate: {
    url: `${backendDomain}/category_create`,
    method: "POST",
  },

  Categoryupdate: {
    url: `${backendDomain}/category_update`,
    method: "POST",
  },

  fetchcategorynames: {
    url: `${backendDomain}/get_category_names`,
    method: "GET",
  },

  Coursecreate: {
    url: `${backendDomain}/course_create`,
    method: "POST",
  },
  Courseupdate: {
    url: `${backendDomain}/course_update`,
    method: "POST",
  },

  CourseList: {
    url: `${backendDomain}/course_retrieve_all`,
    method: "GET",
  },
getActiveCourseNames: {
    url: `${backendDomain}/course_title_retrieve_all_active`,
    method: "get",
  },
  Coursebyid: {
    url: `${backendDomain}/course_admin_retrieve_by_id`,
    method: "POST",
  },
  createCurriculum: {
    url: `${backendDomain}/curriculum_create`,
    method: "POST",
  },
  getCurriculumById: {
    url: `${backendDomain}/curriculum_by_course`,
    method: "POST",
  },
  updateCurriculum:{
    url: `${backendDomain}/curriculum_update`,
    method: "POST",
  },
 updateLesson:{
    url: `${backendDomain}/lesson_update`,
    method: "POST",
  },
  createCourseLesson: {
    url: `${backendDomain}/lesson_create`,
    method: "POST",
  },
  getCourseLessonByCurriculumId: {
    url: `${backendDomain}/lessons_by_curriculum_id`,
    method: "POST",
  },
  getCurriculumByCourseId: {
    url: `${backendDomain}/curriculum_by_course`,
    method: "POST",
  },
  getLessonByCourseId: {
    url: `${backendDomain}/lessons_by_course_id`,
    method: "POST",
  },
 
  createCourseFaqs:{
    url: `${backendDomain}/faq_create`,
    method: "POST",
  },
  getFaqsByCourseID:{
     url: `${backendDomain}/faqs_by_course`,
    method: "POST",
  },
  updateFaqs:{
    url: `${backendDomain}/faq_update`,
    method: "POST",
  },
  createCourseTools:{
    url: `${backendDomain}/tool_create`,
    method: "POST",
  },
  getToolsByCourseId:{
    url: `${backendDomain}/tool_retrieve_by_course_id`,
    method: "POST",
  },
  updateTools:{
   url: `${backendDomain}/tool_update`,
    method: "POST",
  },
  AdminDashboardCounts: {
    url: `${backendDomain}/admin_dashboard_counts`,
    method: "GET",
  },
  AdminDashboardinstructortodayschedule: {
    url: `${backendDomain}/today_time_slot_retrieve_all`,
    method: "GET",
  },
  AdminStudentCreate:{
    url: `${backendDomain}/admin_student_create`,
    method: "POST",
  },
  
  assignCourseToStudent:{
 url: `${backendDomain}/enrollment_create`,
    method: "POST",
  },
 createStudent:{
 url: `${backendDomain}/student_create`,
    method: "POST",
  },
  //create assignment
 CreateAssignment:{
 url: `${backendDomain}/assignment_create`,
    method: "POST",
  },
 assignments_by_instructor_id:{
 url: `${backendDomain}/assignments_by_instructor_course`,
    method: "POST",
  },
 assignment_by_id_retrieve_by_id:{
 url: `${backendDomain}/assignment_retrieve_by_id`,
    method: "POST",
  },
 updateassignment_instructor:{
 url: `${backendDomain}/assignment_update`,
    method: "POST",
  },
 questionary_form_by_assignment:{
 url: `${backendDomain}/questions_by_assignment`,
    method: "POST",
  },
 questionary_by_id:{
 url: `${backendDomain}/question_by_id`,
    method: "POST",
  },
 createquestionaryform:{
 url: `${backendDomain}/question_create`,
    method: "POST",
  },
   updatequestionaryform:{
 url: `${backendDomain}/question_update`,
    method: "POST",
  },
   SaveCourseToStudent:{
 url: `${backendDomain}/save_course`,
    method: "POST",
  },
getSavedcourseStudentId:{
   url: `${backendDomain}/saved_courses_by_student`,
    method: "POST",
},
DeleteSavedCourse:{
   url: `${backendDomain}/delete_saved_course`,
    method: "POST",
},
createBlog:{
  url: `${backendDomain}/blog_create`,
    method: "POST",
},
getAllBlog:{
url: `${backendDomain}/blogs_all`,
    method: "get",
},
getActiveBlog:{
  url: `${backendDomain}/blogs_active`,
    method: "get",
},
updateBlog:{
  url: `${backendDomain}/blog_update`,
    method: "POST",
},
getBlogDetailsbyId:{
  url: `${backendDomain}/blog_by_id`,
    method: "POST",
},
getAssignmentBycourseId:{
   url: `${backendDomain}/assignment_by_course`,
    method: "POST",
},
getQuestionsByAssignmentID:{
 url: `${backendDomain}/questions_by_assignment`,
    method: "POST",
},
LessonClose:{
  url: `${backendDomain}/lesson_closed_create`,
    method: "POST",
},
getAllLessonClosed:{
   url: `${backendDomain}/lesson_closed_all`,
    method: "get",
},
instructorUpdateForgotPassword:{
    url: `${backendDomain}/instructor_update_password`,
    method: "POST",
},
studentUpdateForgotPassword:{
  url: `${backendDomain}/student_update_password`,
    method: "POST",
},

basedontimeslotlessonclosed:{
  url: `${backendDomain}/lesson_closed_by_timeslot`,
    method: "POST",
},

// instructor time slot info
instructorTimeSlotInfo:{
  url: `${backendDomain}/instructor_time_slot_info`,
    method: "POST",
},


studentdashboardtodayclass:{
  url: `${backendDomain}/today_student_time_slot_retrieve_all`,
    method: "POST",
},

getinstructortimeslot:{
  url: `${backendDomain}/get_instructor_timeslot`,
    method: "POST",
},



createtopicclosed:{
  url: `${backendDomain}/topic_closed_create`,
    method: "POST",
},


gettopicclosed:{
  url: `${backendDomain}/topic_closed_by_timeslot`,
    method: "POST",
},

updateassignmentresults:{
  url: `${backendDomain}/result_create`,
    method: "POST",
},


result_by_student_assignment:{
  url: `${backendDomain}/result_by_student_assignment`,
    method: "POST",
},

 
today_student_enrollments:{
  url: `${backendDomain}/today_student_enrollments`,
    method: "GET",
},


instructorregistrationstats:{
  url: `${backendDomain}/instructor_inactive_retrieve_all`,
    method: "GET",
},


instructorcreateproject:{
  url: `${backendDomain}/project_create`,
    method: "POST",
},

instructorupdateproject:{
  url: `${backendDomain}/project_update`,
    method: "POST",
},





instructorretrievebasedontimeslotandcourseid:{
  url: `${backendDomain}/project_retrieve_by_time_slot`,
    method: "POST",
},

instructor_course_timeslots:{
  url: `${backendDomain}/instructor_course_timeslots`,
    method: "POST",
},


enrollment_retrieve_by_slot_and_instructor:{
  url: `${backendDomain}/enrollment_retrieve_by_slot_and_instructor`,
    method: "POST",
},






enrollment_retrieve_by_student_and_course:{
  url: `${backendDomain}/enrollment_retrieve_by_student`,
    method: "POST",
},



enrollment_admin_retrieve_by_student  :{
  url: `${backendDomain}/enrollment_admin_retrieve_by_student`,
    method: "POST",
},

 
  getActiveCoursesBycategory: {
    url: `${backendDomain}/courses_retrieve_by_category_ids`,
    method: "POST",
  },
  


  instructor_retrieve_all_for_activation: {
    url: `${backendDomain}/instructor_retrieve_all_for_activation`,
    method: "GET",
  },
  



student_purchased_courses:{
  url: `${backendDomain}/admin_enrollment_retrieve_by_student`,
    method: "POST",
},

student_exams:{
  url: `${backendDomain}/results_by_student`,
    method: "POST",
},






projects_retrieve_by_student:{
  url: `${backendDomain}/projects_retrieve_by_student`,
    method: "POST",
},


student_project_create :{
  url: `${backendDomain}/student_project_create`,
    method: "POST",
},





student_project_retrieve_by_student:{
  url: `${backendDomain}/student_project_retrieve_by_student`,
    method: "POST",
},


instructor_project_review_update :{
  url: `${backendDomain}/multiple_student_project_review_update`,
    method: "POST",
},


courseByInstructorId: {
    url: `${backendDomain}/instructor_courses`,
    method: "post",
  },

enrollment_retrieve_by_instructor: {
    url: `${backendDomain}/enrollment_retrieve_by_instructor`,
    method: "post",
  },






instructor_by_admin_courses:{
  url: `${backendDomain}/instructor_by_admin_courses`,
    method: "POST",
},




student_generate_certification:{
  url: `${backendDomain}/update_enrollment_completion`,
    method: "POST",
},


get_certification:{
  url: `${backendDomain}/certification_by_student_course`,
    method: "POST",
},



certificate_enrollment_retrieve_by_id: {
    url: `${backendDomain}/certificate_enrollment_retrieve_by_id`,
    method: "POST",
  },






getActiveDegreeCourses: {
    url: `${backendDomain}/course_retrieve_all_degree_active`,
    method: "get",
  },



assignmentupdatelessonbyid: {
    url: `${backendDomain}/assignment_update_lesson_by_id`,
    method: "POST",
  },




verifycertificationbyid: {
    url: `${backendDomain}/enrollment_retrieve_by_certificate`,
    method: "POST",
  },


footercourses: {
    url: `${backendDomain}/course_title_retrieve_all_active`,
    method: "GET",
  },
TopicByCourseId: {
    url: `${backendDomain}/open_curriculum_by_course`,
    method: "POST",
  },
  LessonByTopicId:{
      url: `${backendDomain}/open_lessons_by_curriculum`,
    method: "POST",
  },
  assignmentByCourseId:{
    url: `${backendDomain}/assignments_by_instructor_course`,
    method: "POST",
  },



  assignmentsallbasedontimeslotbyid:{
    url: `${backendDomain}/assignments_by_filters`,
    method: "POST",
  },


  assignmentsstudentstatusallbasedontimeslotbyid:{
    url: `${backendDomain}/assignment_result_by_filters`,
    method: "POST",
  },


  coursecompleteupdate:{
    url: `${backendDomain}/time_slot_update_completed`,
    method: "POST",
  },




  instructorTimeslotByInstructorIdandtimeslotid: {
    url: `${backendDomain}/instructor_timeslots_by_id`,
    method: "post",
  },




  studentTimeslotByandtimeslotid: {
    url: `${backendDomain}/today_student_time_slot`,
    method: "post",
  },


};

export default SummaryApi;
